<template>
  <div class="mobile-app-tiles">
    <mobile-app-tiles-item
      v-for="(tile, index) in tiles"
      :key="index"
      :title="tile.title"
      :image="tile.image"
    />
  </div>
</template>

<script>
import MobileAppTilesItem from "@/components/mobile-app/MobileAppTilesItem.vue";
import tileImage1 from "@/assets/mobile-app/icon-stock.png";
import tileImage2 from "@/assets/mobile-app/icon-top-up-your-account.png";
import tileImage3 from "@/assets/mobile-app/icon-tv.png";
import tileImage4 from "@/assets/mobile-app/icon-technical-support.png";

export default {
  name: "MobileAppTiles",
  components: {
    MobileAppTilesItem,
  },
  setup() {
    const tiles = [
      { title: "Підключайте акції та послуги", image: tileImage1 },
      { title: "Поповнюйте рахунок", image: tileImage2 },
      { title: "Дивіться ТБ та фільми", image: tileImage3 },
      { title: "Пишіть у підтримку", image: tileImage4 },
    ];

    return {
      tiles,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.mobile-app-tiles {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 320px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media @md {
    gap: 25px;
    grid-template-columns: repeat(3, 1fr);
  }

  @media @lg {
    gap: 30px;
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
